import React from 'react'
import {useIntl, defineMessages} from 'react-intl'

const messages = defineMessages({
    newsletterEmail: {
        defaultMessage: 'Enter your email',
        id: 'newsletter_email.label'
    }
})

export default function useNewsletterSignUp({
    form: {
        control,
        formState: {errors}
    } = {},
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const fields = {
        "newsletterEmail": {
            name: `${prefix}newsletterEmail`,
            label: formatMessage(messages.newsletterEmail),
            defaultValue: '',
            type: 'email',
            rules: {
                required: formatMessage({
                    defaultMessage: 'Please fill out this field',
                    id: 'required_field.label'
                }),
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: formatMessage({
                        defaultMessage: 'Please provide a valid email address',
                        id: 'newsletter.field.error.email'
                    })
                }
            },
            error: errors[`${prefix}newsletterEmail`],
            control,
            placeholder: formatMessage(messages.newsletterEmail),
            hideLabel: true
        }
    }

    return fields
}
